<template>
	<div>
		<ProgramFilters :live="true" />
		<ProgramTable />
	</div>
</template>

<script setup lang="ts">
import ProgramTable from '@ProgramList/components/ProgramTable.vue';
import ProgramFilters from '@ProgramList/components/ProgramFilters.vue';
</script>
